import '.c7{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.av{position:absolute;}.ssr-plugin'
import '.e0{top:0px;}.ssr-plugin'
import '.gs{right:-4px;}.ssr-plugin'
import '.dw{width:1.5rem;}.ssr-plugin'
import '.dx{height:1.5rem;}.ssr-plugin'
import '.ag{border-radius:1.25rem;}.ssr-plugin'
import '.gt{background-color:var(--brand-primary);}.ssr-plugin'
import '.at{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  isUploadPreview = false,
  onDelete,
  onCancelDelete,
}: {
  src: string
  isUploadPreview?: boolean
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="c7 a b f"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        resizeWidth={90}
        ignoreResize={isUploadPreview}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--palette-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="a b f av e0 gs dw dx ag gt at"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--palette-white)" />
    </div>
  )
}
